<template>
    <v-dialog v-model="dialog" max-width="400" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.note_from_coach') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" class="text-center">
                        {{ message }}
                    </v-col>
                    <v-col cols="12">
                        <v-img :src="imgPlaceholder" width="30" class="ml-auto" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapMutations, mapState } from "vuex";

export default {
    name: "NoteMessageDialog",
    data() {
        return {
            dialog: false,
            message: ''
        }
    },
    computed: {
        ...mapState(['dialogActive']),
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show(message) {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
            vm.message = message
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.message = ''
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>